<template>  
<div class="p-relative">
  <b-button size="lg" variant="dark" class="btn-show-list" @click="clickShowListButton" :class="typeNavigationShowing? 'show':''">
    <font-awesome-icon :icon="['fas', 'angle-right']" />
  </b-button>

  <div class="type-nav d-flex align-items-center" :class="typeNavigationShowing? 'show':''">
    <!-- <aside @mousewheel="scrollEvent"> -->
    <aside>
      <ul class="list-unstyled my-5">
        <li v-for="(type, i) in types" :key="type.id" class="py-1">
          <b-button v-if="typeArrayIndex == i" variant="dark" size="lg" @click="setTypeNavigationShowing(false)">
            {{ type.name }}
            <font-awesome-icon  class="ml-2" :icon="['fas', 'angle-left']" />
          </b-button>
          <router-link v-else class="btn btn-dark" :to="{name: 'Type', params: {typeArrayIndex: ''+i}}">
            {{ type.name }}
          </router-link>
        </li>
      </ul>
    </aside>
  </div>
</div>

</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  name: 'TypeNavigation',
  computed: {
    ...mapState({
      types: state => state.types,
      typeArrayIndex: state => state.typeArrayIndex,
      typeNavigationShowing: state => state.typeNavigationShowing
    })
  },
  methods: {
    ...mapActions({
      setTypeNavigationShowing: 'doSetTypeNavigationShowing'
    }),

    scrollEvent(event) {
      // console.log('typeNavDidScroll', event)
      if(event.deltaY > 0) {
        // 自身を引っ込めることで画面をスクロールさせる
        this.setTypeNavigationShowing(false)
      }
    },
    clickShowListButton() {
        this.setTypeNavigationShowing(true)
    }
  }
}
</script>
<style lang="scss">
.type-nav {
  .btn {
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, font-size 0.15s ease-in-out, padding 0.15s ease-in-out;
  }
}
</style>
<style lang="scss" scoped>
.type-nav {
  position: fixed;
  top: 0;
  left: 0;
  // width: 240px;
  height: 100%;
  z-index: 19;
  transition: left 1.0s;
  pointer-events: none;
  >aside {
    position: relative;
    transition-duration: 0.6s;
    transition-property: left, opacity;
    left: -100px;
    opacity: 0;
    overflow: scroll;
    height: 100%;
    >ul {
      // height: calc(100% + 50px);
    }
  }
  &.show {
    pointer-events: auto;
    >aside {
      left: 0;
      opacity: 1;
    }
  }
}
.btn-show-list {
  position: absolute;
  z-index: 21;;
  top: 100px;
  left: 0px;
  opacity: 1; 
  transition: left 0.6s, opacity 0.6s;
  &.show {
    left: -100px;
    opacity: 0;

  }
}

</style>